import { z } from 'zod';

import { BlockTextField } from '../../../ConfigFields/TextField';
import { type BlockConfigProps } from '../../../types';

const WAIT_TIME_HELPER_TEXT = 'Amount of time to wait before executing the next block(s).';

function FormFields() {
  return (
    <BlockTextField
      fieldName="config.waitTimeMillis"
      label="Wait Time (ms)"
      type="number"
      slotProps={{
        htmlInput: {
          min: 1,
          step: 1,
        },
      }}
      helperText={WAIT_TIME_HELPER_TEXT}
    />
  );
}

const documentationMarkdown = `
# Wait for time

Wait for a specified amount of time in milliseconds.
`;

export const waitConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'wait',
  defaultConfig: {
    waitTimeMillis: 1000,
  },
  configFields: {
    schema: z.object({
      waitTimeMillis: z
        .number({ message: `Required - ${WAIT_TIME_HELPER_TEXT}` })
        .positive()
        .int()
        .max(5 * 60 * 1000, 'Max wait time is 5 minutes'),
    }),
    FormFields,
  },
  documentationMarkdown,
};
